<template>
    <div
        class="taker-card"
        :class="{'active': selectedTakerUid === taker.uid}"
        @click="showTakerDetails"
    >
        <div class="data">
            <img :src="taker.logo ? taker.logo : defaultTakerLogo">
            <div class="card-title">{{ taker.name }}</div>
        </div>
        <div class="action" v-if="displayActions">
            <el-button
                v-if="selectedTakerUid === taker.uid"
                class="action-button"
                icon="el-icon-arrow-left"
                circle
            ></el-button>
            <el-button
                v-else
                class="action-button"
                icon="el-icon-arrow-right"
                circle
            ></el-button>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        taker: {
            type: Object,
            required: true
        },
        selectedTakerUid: {
            type: String,
            required: true
        },
        displayActions: {
            type: Boolean,
            default: true,
        },
    },

    data: function(){
        return {
            defaultTakerLogo: '../../../../static/image/default-taker-logo.png'
        };
    },

    computed: {

    },

    mounted: function(){

    },

    methods: {
        showTakerDetails() {
            this.$emit('changeSelectedTaker', this.taker.uid);
        }
    },
};
</script>

<style lang="scss">
.taker-card {
    cursor: pointer;
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    background-color: #222;
    border-radius: 4px;
    &.active {
        background-color: #333;
    }
    .data{
        flex-basis: 70%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        *{
            flex-basis: 60%;
        }
        img{
            flex-basis: 20%;
            width: 60px;

        }
        .card-title {
            color: #EEE;
        }
    }
    +.taker-card {
        margin-top: 10px;
    }
    .action-button {
        color: #CCC;
        font-size: 30px;
        background-color: unset;
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Takers/takerCard.vue